export type InputType =
  | 'color'
  | 'email'
  | 'file'
  | 'number'
  | 'password'
  | 'range'
  | 'search'
  | 'tel'
  | 'text'
  | 'url';
